module.exports = __webpack_public_path__ + "static/media/medium.db0433bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/medium.jpg
// module id = 1144
// module chunks = 0